<template>
  <div>
    <ActionsMenu
      v-if="actions.length"
      :actions="actions"
      :options="{ theme: 'light equipment-context-tooltip' }"
      @edit-equipment="toggleModal"
    />
    <EquipmentModal
      v-if="modalOpen"
      :equipment-id="equipment.id"
      :customer-id="customerId"
      @hide-modal="toggleModal"
      @save-success="refreshDatatable"
    />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import ActionsMenu from "@/components/ActionsMenu.vue";
import EquipmentModal from "@/Equipment/EquipmentModal.vue";

export default {
  components: {
    ActionsMenu,
    EquipmentModal
  },
  props: {
    customerId: {
      type: Number,
      default: null
    },
    equipment: {
      type: Object,
      default: null
    },
    equipmentComponent: {
      type: Object,
      default: null
    },
    component: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modalOpen: false,
      actions: this.getActions()
    };
  },
  methods: {
    getActions() {
      const equipment = this.equipment || {};
      const equipmentComponent = this.equipmentComponent || {};
      const actions = [
        {
          label: "Edit",
          icon: "fa-regular fa-edit",
          eventName: "edit-equipment"
        },
        {
          html: this.getDatesContent(equipmentComponent, equipment),
          className: "equipment-context-menu-dates"
        }
      ];
      return actions;
    },
    getDatesContent(equipmentComponent, equipment) {
      return `
      <div><b style="margin-right:4px">Equipment Notes:</b> <br/> ${
        equipment.notes ? equipment.notes : "--"
      }</div>
`;
    },
    refreshDatatable() {
      EventBus.$emit("refresh-customer-equipment-datatable");
      EventBus.$emit("refresh-datatable");
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    }
  }
};
</script>

<style lang="scss">
.tippy-tooltip.equipment-context-tooltip-theme {
  ul li {
    .equipment-context-menu-notes {
      span {
        white-space: pre-line;
      }
    }
  }
  .tippy-content {
    width: 190px;
  }
}
</style>
